import React from "react";
import DrawerCustom from "./Drawer";
import refresh from "../assets/images/refresh.jpeg";
import {setShowMembership, useUser} from "../useAppPullState";
import logo from "../assets/images/mini-logo.jpeg";
import {syncWithServer} from "./actions/syncWithServer";
export const refreshPage = () => {
    window.location.reload();
}

export default () => {
    const [authUser, setAuthUser] = useUser();

    return (
        <div style={{paddingTop: 12}}>
      <span style={{paddingLeft: 16}}>
        <img
            src={refresh}
            class='img-fluid rounded-start'
            alt='...'
            style={{height: 47, width: 57, position: "relative", left: "2%", cursor: "pointer"}}
            onClick={refreshPage}
        />
          {/* <Refresh /> */}
      </span>{" "}
            <img
                src={logo}
                class='img-fluid rounded-start'
                alt='...'
                height={50}
                style={{height: 60, position: "relative", left: "27%", cursor: "pointer"}}
                onClick={() => window.location.reload()}
            />
            <DrawerCustom
                setAuthUser={setAuthUser}
                authUser={authUser}
                setShowMembership={setShowMembership}
            />
        </div>
    );
};
